'use client';
import { createContext, useContext } from 'react'
export const GroupContext = createContext({
  group: null,
  mutate: async () => null,
  error: null 
})
export const useGroup = () => useContext(GroupContext)